import { Box, styled } from '@mui/material';
/**
 * Styled div for the load mask.
 */
export const StyledLoadMask = styled(Box)({
    backgroundColor: 'rgba(255,255,255,0.5)',
    display: 'flex',
    height: '100%',
    padding: '0.25rem',
    position: 'absolute',
    width: '100%',
    zIndex: 30,
    svg: { zIndex: 10000 },
});
